import PropTypes from "prop-types";

import sentry from "utils/sentry";

import SentryBoundary from "components/libraries/sentry-boundary";

const NonMuiWrapper = ({ children }) => (
  <SentryBoundary sentry={sentry}>{children}</SentryBoundary>
);
NonMuiWrapper.propTypes = { children: PropTypes.element.isRequired };

export default NonMuiWrapper;
